import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';
import { getUserProfileDetail,updateUserProfile } from "../../utils/admin/dashboardApi";

export default function MyProfile() {
    const [profileData, setProfileData] = useState({
        fname: "",
        lname: "",
        dob: "",
        mobile: "",
        avatar: "",
    });
    const [avatarPreview, setAvatarPreview] = useState(null);
    const [avatarFile, setAvatarFile] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Fetch user profile data
    const fetchProfileData = async () => {
        setIsLoading(true);
        try {
            const result = await getUserProfileDetail();
            if (result && result.data) {
                setProfileData({
                    fname: result.data.fname || "",
                    lname: result.data.lname || "",
                    dob: result.data.dob || "",
                    mobile: result.data.mobile || "",
                    avatar: result.data.avatar || "",
                });

                // Set avatar preview if exists
                if (result.data.avatar) {
                    setAvatarPreview(result.data.avatar);
                }

                // Update session storage with new email
                sessionStorage.setItem("user_detail", JSON.stringify(result.data));
            }
        } catch (error) {
            toast.error(`${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchProfileData();
    }, []);

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle avatar file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAvatarFile(file);
            setAvatarPreview(URL.createObjectURL(file)); // Show preview
        }
    };

    // Handle profile update
    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const formData = new FormData();
            formData.append("fname", profileData.fname);
            formData.append("lname", profileData.lname);
            formData.append("dob", profileData.dob);
            formData.append("mobile", profileData.mobile);

            // Append avatar file if selected
            if (avatarFile) {
                formData.append("avatar", avatarFile);
            }
            //Call Api
            const response = await updateUserProfile(formData);
            //Check if true or not
            if (response.status === true) {
                toast.success(response.message);
                // Fetch Updated Profile Data
                fetchProfileData();
                // Wait for 3 seconds, then refresh the page
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="container-scroller admin-dashboard-page">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />

                        <div className="admin-my-profile-page">
                        <div className="mt-4 px-4 pb-4 w-100 admin-my-profile-body">
                        <div className="my-profile-saction">
                            <div className="my-profile-saction-inner">
                            {isLoading ? (
                                <div className="loader-container">
                                    <div className="spinner"></div>
                                    <p>Loading please wait...</p>
                                </div>
                            ) : (
                            <>
                                <div className="admin-profile-page-header">
                                    <h2>Profile</h2>
                                    <p className="admin-profile-page-subtitle">Update your name, photo, and contact details.</p>
                                </div>
                                <div className="profile-from admin-my-profile-form">
                                    <form onSubmit={handleUpdateProfile}>
                                        <div className="admin-profile-avatar-block">
                                            <div className="avatar-upload admin-profile-avatar-circle">
                                                <label>
                                                    <div className="icon-image"><i className="fa fa-file-image-o" aria-hidden="true"></i></div>
                                                    <span className="admin-profile-upload-hint">Choose photo</span>
                                                    <div className="avatar-preview">
                                                        {avatarPreview ? (
                                                            <img src={avatarPreview} alt="Avatar Preview" />
                                                        ) : (
                                                            <p></p>
                                                        )}
                                                    </div>
                                                    <input type="file" accept="image/*" name="avatar" onChange={handleFileChange} />
                                                </label>
                                            </div>
                                            <div className="admin-profile-avatar-help">
                                                <h3>Profile photo</h3>
                                                <p>JPG or PNG. Click the circle to upload a new image.</p>
                                            </div>
                                        </div>

                                        <div className="row g-3">
                                            <div className="col-12 col-md-6">
                                                <div className="form-box-row">
                                                    <label htmlFor="admin-profile-fname">First name</label>
                                                    <input id="admin-profile-fname" className="form-control admin-profile-input" type="text" placeholder="First name" name="fname" value={profileData.fname} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-box-row">
                                                    <label htmlFor="admin-profile-lname">Last name</label>
                                                    <input id="admin-profile-lname" className="form-control admin-profile-input" type="text" placeholder="Last name" name="lname" value={profileData.lname} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-3 mt-0">
                                            <div className="col-12 col-md-6">
                                                <div className="form-box-row">
                                                    <label htmlFor="admin-profile-dob">Date of birth</label>
                                                    <input id="admin-profile-dob" className="form-control admin-profile-input" type="date" name="dob" value={profileData.dob} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-box-row">
                                                    <label htmlFor="admin-profile-mobile">Mobile number</label>
                                                    <input id="admin-profile-mobile" className="form-control admin-profile-input" type="tel" placeholder="Mobile number" name="mobile" value={profileData.mobile} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="admin-profile-form-actions">
                                            <div className="button-save">
                                                <button type="submit" disabled={isSubmitting}>{isSubmitting ? "Saving…" : "Save changes"}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                </>
                                )}
                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}
